module.exports = __webpack_public_path__ + "static/media/oneX_Sodium_Borate_Buffer.d6c18edb.svg";